const config = {
  configEndpoints: {
    baseEndpoint: "https://api.hub.affinity.io",
  },
  configGoogleTagManager: {
    gtmId: "GTM-NL6LH2C",
  },
  configLiveChat: {
    script: "//js.hs-scripts.com/8487018.js?businessUnitId=108691",
  },
  configIntercom: {
    enabled: true,
  },
  configLogicMonitor: {
    baseUrl: "https://dc.api.masro.io/uat",
    jsBundleUrl: "https://s3.eu-west-2.amazonaws.com/dc.logic-one.io/js/logicone.js",
  },
};

export default config;
